/* eslint-disable max-len */
import constants from 'src/common/constants';

export const getDefaultDeliveryMethod = (state) => state.all.find((deliveryMethod) => deliveryMethod.id === constants.DEFAULT_PAYMENT_METHOD);
